import { render, staticRenderFns } from "./reserveList.vue?vue&type=template&id=1b05d48d&scoped=true&"
import script from "./reserveList.vue?vue&type=script&lang=js&"
export * from "./reserveList.vue?vue&type=script&lang=js&"
import style0 from "./reserveList.vue?vue&type=style&index=0&id=1b05d48d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05d48d",
  null
  
)

export default component.exports